var $body, 
    $footer, 
    $footer_help, 
    $footer_help_pop_up, 
    $footer_help_trigger,
    height,
    footer_height,
    scrollTop,
    scrollBottom;

export default function helpToggle() {
    var velocity = require('velocity');

    $.fn.scrollBottom = () =>
         $(document).height() - $(window).scrollTop() - $(window).height();
    $.fn.velocity = velocity;
     
    $body = $('body');
    $footer = $('.footer');
    $footer_help = $('.footer__help');
    $footer_help_pop_up = $('.footer__help__pop-up');
    $footer_help_trigger = $('.footer__help__trigger');

    $(window).on('load resize scroll', function(){
        checkOffset();
        checkWindowSize();

    });

    $(window).on('load', function(){
        var _hasCookie = document.cookie.match(/(?:(?:^|.*;\s*)helptoggle\-cookie\s*\=\s*([^;]*).*$)|^.*$/)[1];

        if (typeof _hasCookie === 'undefined' || _hasCookie === 'false') {
            beginAnimation();
        }
        else {
            $footer_help_pop_up.css({top: 400, opacity: 0, display: 'none'});
            $footer_help.css({right: 25, opacity: 1});
        }
    });

    $('.footer__help__trigger').on('click', function() {
        popupSlideUp($footer_help_pop_up);
        $footer_help_pop_up.addClass('active');
    });

    $('.footer__help__icon--close').on('click', function() {
        $footer_help_pop_up.removeClass('active');
        popupSlideDown($footer_help_pop_up);
    });

    $footer_help_trigger.on('mouseenter', function() {
        $('.footer__help__trigger__help-balloon').velocity({
            width: "100%"
        },{
            duration: 100,
            easing: "lineair"
        });
    });

    $footer_help_trigger.on('mouseleave', function() {
        $('.footer__help__trigger__help-balloon').velocity({
            width: 48
        },{
            duration: 100,
            easing: "lineair"
        });
    });
}

function checkWindowSize() {
    var width = $(window).width(),
        new_class = (width > 768 && width < 992) ? 'medium': (width > 992) ? 'large' : '';

    $footer.removeClass('medium large').addClass(new_class);
    if ($footer.hasClass('medium') && scrollBottom <= 412) {

        $footer_help.removeClass('fixed').css({'position':'absolute','bottom': 406});

    } else if( $footer.hasClass('large') && scrollBottom <= 466) {

        $footer_help.removeClass('fixed').css({'position':'absolute','bottom': 462});

    } else {

        $footer_help.addClass('fixed').css({'position':'fixed','bottom': 0});
    }
}

function checkOffset() {
    height = $(window).height();
    footer_height = $footer.height();
    scrollTop = $(window).scrollTop();
    scrollBottom = $(window).scrollBottom();
}

function popupSlideDown(element) {
    element.velocity({
        top: 400,
        opacity: 0
    }, {
        duration: 1000,
        display: "none",
        easing: "ease-in-out"
    });
}

function popupSlideUp(element) {
    element.velocity({
        top: 0,
        opacity: 1
    }, {
        duration: 1000,
        display: "block",
        easing: "ease-in-out"
    });
}

function beginAnimPopup(element) {
    element.velocity({
        top: 400,
        opacity: 0
    }, {
        duration: 1000,
        display: "none",
        easing: "ease-in-out",
        delay: 2000
    });
}

function beginAnimation(element) {
    $footer_help.velocity({
        right: 25,
        opacity: 1
    }, {
        duration: 1000,
        easing: "ease-in-out",
        complete: beginAnimPopup($footer_help_pop_up),
        delay: 1000
    });

    document.cookie = 'helptoggle-cookie=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
}


// WEBPACK FOOTER //
// ./src/Resources/ui/js/helpToggle.js